// Constantes de negócio ficam aqui — nenhuma página repete string solta de status/perfil.

export const PERFIL_OPCOES = [
  { value: 'admin', label: 'Administrador', descricao: 'Tudo, incluindo apagar evento e ver segredo em claro' },
  { value: 'operador', label: 'Operador', descricao: 'Cria e edita endpoints, reenvia eventos' },
  { value: 'consulta', label: 'Consulta', descricao: 'Só visualiza eventos; segredos aparecem mascarados' },
];

export const AUTH_TIPO_OPCOES = [
  { value: 'nenhum', label: 'Nenhuma', descricao: 'Aceita qualquer chamada — use para capturar e descobrir o formato' },
  { value: 'token', label: 'Token em cabeçalho', descricao: 'O provedor manda um valor fixo que comparamos' },
  { value: 'hmac', label: 'Assinatura HMAC', descricao: 'O provedor assina o corpo com um segredo compartilhado' },
  { value: 'basic', label: 'Basic Auth', descricao: 'Usuário e senha no cabeçalho Authorization' },
];

export const STATUS_EVENTO_LABELS = {
  recebido: 'Recebido',
  rejeitado: 'Rejeitado',
  erro: 'Erro',
};

export const AUTH_RESULTADO_LABELS = {
  nao_aplicavel: 'Sem validação',
  valido: 'Credencial válida',
  invalido: 'Credencial inválida',
  ausente: 'Credencial ausente',
};

export const ENCAMINHADO_LABELS = {
  nao: 'Não encaminhado',
  sucesso: 'Encaminhado',
  falha: 'Falha no encaminhamento',
};

export const METODOS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD'];

export const PERIODOS = [
  { value: 7, label: '7 dias' },
  { value: 30, label: '30 dias' },
  { value: 90, label: '90 dias' },
];

export const labelPerfil = (perfil) => PERFIL_OPCOES.find((p) => p.value === perfil)?.label || perfil;
export const labelAuthTipo = (tipo) => AUTH_TIPO_OPCOES.find((t) => t.value === tipo)?.label || tipo;
